export const GET_CONSULTANTS = 'get_consultants';
export const GET_CONSULTANT_PROJECTS = 'get_consultant_projects';
export const UPDATE_PROJECT_TIME = 'update_project_time';
export const GET_PROJECT_ACTIVITIES = 'get_projects_activities';
export const GET_PUBLIC_HOLIDAYS = 'get_public_holidays';
export const ERROR = "error";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";